import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";
import { getEnv } from "../config";

const tieneFuncionalidad = (usuario, funcionalidadesRequeridas) => {
  if (!usuario || !usuario.funciones) return false;
  return funcionalidadesRequeridas.some((funcRequerida) =>
    usuario.funciones.some((func) => func.descripcion === funcRequerida)
  );
};

export default function ProtectedRoute({ funcionalidadesRequeridas }) {
  const authState = JSON.parse(localStorage.getItem("auth"));

  // Si no está autenticado, redirige a la página de login
  if (authState?.token) {
    // Verifica si el usuario tiene al menos una de las funcionalidades requeridas
    const tieneAcceso = tieneFuncionalidad(
      authState?.usuario,
      funcionalidadesRequeridas
    );
    // Si no tiene ninguna de las funcionalidades requeridas, redirige a la página de acceso denegado
    if (!tieneAcceso) {
      return <Navigate to="/acceso-denegado" replace />;
    }
  } else {
    return <Navigate to="/acceso-denegado" replace />;
  }

  // Si tiene al menos una de las funcionalidades requeridas, renderiza las rutas hijas
  return <Outlet />;
}
